/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_SessionInputs */

const en_us2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change to a plan day`)
};

const pt_br2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração em um dia do plano`)
};

const es_419_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio en un día del plan`)
};

const pt_pt2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração num dia do plano`)
};

const fr_fr2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification d'un jour du programme`)
};

const de_de2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung an einem Plantag`)
};

const it_it2_offline_kind_plan_session = /** @type {(inputs: Offline_Kind_Plan_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica a un giorno della scheda`)
};

/**
* | output |
* | --- |
* | "Change to a plan day" |
*
* @param {Offline_Kind_Plan_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_session = /** @type {((inputs?: Offline_Kind_Plan_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_session(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_session(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_session(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_session(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_session(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_session(inputs)
	return en_us2_offline_kind_plan_session(inputs)
});
export { offline_kind_plan_session as "offline.kind_plan_session" }